import Axios, { AxiosError, Method } from 'axios';
import { IRequestObject, ITranslatable } from '../common/interfaces/api.interface';
import ApiHelper from '../helpers/ApiHelper';
import config from '../../config';
import ApplicationError from '../errors/application-error';
import { EErrorMessage } from '../common/enums/messages.enum';

export default abstract class ApiRoutes<TResponse = undefined, TRequestData = undefined, TRequestParams = undefined> {
  private readonly baseUrl: string;
  private readonly method: Method;
  private readonly url: string;
  private readonly withCredentials: boolean;

  protected constructor(url: string, method: Method, withCredentials = false, baseUrl: string) {
    this.baseUrl = baseUrl;
    this.method = method;
    this.url = url;
    this.withCredentials = withCredentials;
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }

  public getMethod(): Method {
    return this.method;
  }

  public getUrl(): string {
    return this.url;
  }

  public getWithCredentials(): boolean {
    return this.withCredentials;
  }

  public async fetch(requestObject: IRequestObject<TRequestData, TRequestParams> = {}): Promise<TResponse> {
    let data;
    try {
      const requestConfig = ApiHelper.getRequestConfig(this, requestObject);
      if(requestObject.ordersSwitchActive) {
        requestConfig.baseURL = config.api.baseurl + config.api.paths.orders.basepath;
      }
      ({ data } = await Axios.request(requestConfig));
    } catch (err) {
      if((err as AxiosError).isAxiosError) {
        ApiHelper.handleKnownApiError(err as AxiosError<{ details?: (string | ITranslatable)[]; message?: string }>, this);
      } else {
        throw new ApplicationError(EErrorMessage.UNKNOWN, err instanceof Error ? err : undefined);
      }
    }
    if(this.baseUrl === config.api.baseurl) {
      return ApiHelper.cleanResponseData<TResponse>(data) as unknown as TResponse;
    }
    return data;
  }
}
